import { useState } from 'react';
import styles from './Gallery.module.css';

export default function Gallery({ images, autoPlay = false, autoPlayInterval = 3000 }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className={styles.gallery}>
      <div className={styles.imageContainer}>
        <button 
          className={`${styles.arrow} ${styles.arrowLeft}`}
          onClick={goToPrevious}
          aria-label="Previous image"
        >
          &#8249;
        </button>
        
        <div className={styles.imageWrapper}>
          <img 
            src={images[currentIndex].src} 
            alt={images[currentIndex].alt || `Gallery image ${currentIndex + 1}`}
            className={styles.galleryImage}
          />
        </div>
        
        <button 
          className={`${styles.arrow} ${styles.arrowRight}`}
          onClick={goToNext}
          aria-label="Next image"
        >
          &#8250;
        </button>
      </div>
      
      <div className={styles.dots}>
        {images.map((_, index) => (
          <button
            key={index}
            className={`${styles.dot} ${index === currentIndex ? styles.dotActive : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to image ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
